import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=792d3678&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('792d3678')) {
      api.createRecord('792d3678', component.options)
    } else {
      api.reload('792d3678', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=792d3678&", function () {
      api.rerender('792d3678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RvuKlSpKx80Z/JS/cancellationPolicy.vue"
export default component.exports